//import 'bootstrap';
import { Tooltip, Toast, Popover, Modal } from 'bootstrap';
// import Swiper JS
//import Swiper, { Navigation, Pagination, Mousewheel } from 'swiper';
import Swiper, { Navigation, Mousewheel, Lazy } from 'swiper';
import Alpine from 'alpinejs'
//import Alpine from "alpinejs/src/index.js";
import intlTelInput from 'intl-tel-input';

Swiper.use([Navigation, Mousewheel, Lazy]);

window.$ = $;
// set a css variable of the scrollbar width (used in slider calculations)
document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + "px");

// Load below on document ready
$( function(){
    window.fromental = {}; // Object to store all of our variables and functions
    window.fromental.sliders = {
        desktop: true, // Set false when moved to mobile side
    }

    // Initialise Alpine
    window.Alpine = Alpine
    Alpine.store('cart', {
        data: false,     
        update() {
            this.data = window.cart;
            //console.log(this.data);
        }
    })
    
    // Alpine cart data functions
    document.addEventListener('alpine:init', () => {
        Alpine.data('alpineMiniCartData', () => ({
            loading: false,
			getCurrency: function() {
				if ( window.hasOwnProperty('currentCurrency') ){
					var cc = window.currentCurrency;
					if (cc == "GBP"){
						return "£";
					} else if (cc == "USD") {
						return "$"
					} else if (cc == "EUR") {
						return "€";
					} else {
						return cc + " ";
					}
				} else {
					return "";
				}
			},
            numberWithCommas: function(x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            },
            renderProductSize: function(item){
                var height = false;
                var width = false;

                if (item.hasOwnProperty('metafields')){
                    if (item.metafields.hasOwnProperty('panel_height')){
                        if (item.metafields.panel_height.hasOwnProperty('value')){
                            height = item.metafields.panel_height.value;
                        }
                    }
                    if (item.metafields.hasOwnProperty('panel_width')){
                        if (item.metafields.panel_width.hasOwnProperty('value')){
                            width = item.metafields.panel_width.value;
                        }
                    }
                }

                if (item.hasOwnProperty('variant_title') && !item.variant_title.toLowerCase().includes("default") ){
                    height = item.variant_title;
                }

                if (height && width){
                    return width + " x " + height;
                } else if (height){
                    return height
                } else if (width){
                    return width
                } else {
                    return "";
                }
            },
            adjustQuantity: function(id, qty){
                //alert("adjust product quantity in cart: " + id + " to new qty: " + qty);
                this.loading = true;
                var that = this;
                $.ajax({
                    type: 'POST',
                    url: '/cart/change.js',
                    dataType: 'json',
                    data: {
                        'id' : parseFloat(id),
                        'quantity': parseInt(qty)
                    },
                    success: function(data) { 
                        // Update the window.cart and alpine js
                        window.cart = data;
                        window.Alpine.store('cart').update();
                        that.loading = false;
                        updateMiniCart();
                    }
                });
            },
            removeProduct: function(id){
                this.loading = true;
                var that = this;
                $.ajax({
                    type: 'POST',
                    url: '/cart/change.js',
                    dataType: 'json',
                    data: {
                        'id' : parseFloat(id),
                        'quantity': 0
                    },
                    success: function(data) { 
                        // Update the window.cart and alpine js
                        window.cart = data;
                        window.Alpine.store('cart').update();
                        that.loading = false;
                        updateMiniCart();
                    }
                });
            }
        }))
    })

    // Init Alpine
    Alpine.start()

    // International telephone input plugin
    const phone_inputs = $("input[type=tel]");
    phone_inputs.each( function(){
       var input = $(this);
       var iti = intlTelInput($(this)[0], {
        // initialisation options.
        initialCountry: "GB",
        nationalMode: false,
        //hiddenInput: "phone",
        separateDialCode: false,
        utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.17/js/utils.min.js"
        });

        // Add listener
        $(this).on('change', function(){
            //console.log("number changed: " + iti.getNumber());
            input.val(iti.getNumber());
        });
    })

    // Pinboard add click
    $('.swym-add-to-wishlist-view-product').on( "click", function(event){
        event.preventDefault();
        //console.log("add to pinboard");
    });

    // Add variant to cart
    window.fromental.addVariantToCart = function(btn){
        var variant_id = $(btn).attr("data-variant-id");
        $(btn).find('.inner').text("Adding");
        //$(btn).attr('disabled',true);
        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                "id": variant_id,
                "quantity": 1
            },
            dataType: 'json',
            success: function() {
                $(btn).find('.inner').text("Added");
                updateMiniCartCount();
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true  //this code is for prestige theme, is to refresh the cart
             }));
            }
        });
    }

    // variant changer
    $('#variant-selector').on('change', function(){
        window.location.href = $(this).val();
    });

    // Variant image clicks
    /**
    $('.product-page .variant').on('click', function(){
        $('.variant-select').val($(this).attr('data-variant-value'));
        // Trigger change event on variant-selects element
        const vtrigger = $('.variant-selects-trigger');
        if (vtrigger.length){
            vtrigger[0].onVariantChange();
        }
    });
    **/

    // Function for updating mini cart
    function updateMiniCartCount() {
        // Show Toast
        var toastElList = [].slice.call(document.querySelectorAll('.product-added-toast'))
        var toastList = toastElList.map(function(toastEl) {
          return new Toast(toastEl)
        })
        toastList.forEach(toast => toast.show());
        updateMiniCart();
    }

    // Listen for the cart added event.
    window.addEventListener('fromentalProductAdded', updateMiniCartCount, false);


    // Update mini cart
    function updateMiniCart(){
        $.ajax({
            type: 'GET',
            url: '/cart?view=custom.json',
            dataType: 'json',
            success: function(data) { 
                var item_count = data.item_count;
        
                // Update the item count in your header here...
                $('#nav #counter').text(item_count);

                // Update the window.cart and alpine js
                window.cart = data;
                window.Alpine.store('cart').update();
            }
        });
    }

    // Switch image alt src
    function switchAltImage(img){
        var src_old = img.attr("src");
        var src_new = img.attr("data-src-alt");
        img.attr("src", src_new);
        img.attr("data-src-alt", src_old);
    }

    // Helper function to invert nav/header images
    function invertHeaderImages(){
        switchAltImage($('#logo'));
        switchAltImage($('#nav-menu-toggle img.open'));
        switchAltImage($('#nav-menu-toggle img.closed'));
        switchAltImage($('#nav-search-toggle img'));
        switchAltImage($('.menu-item-icon-pin img'));
    }

    var headerOpen = false; // set true when header is open
    var menuOpen = false; // set true when menu is open

    //////////////////////
    // Open/Close Menu //
    ////////////////////
    function headerOpenMenu(){
        $('#nav').removeClass('closed').addClass('open');
        $('#nav-menu-toggle').removeClass('closed').addClass('open');
        $('#nav-menu').removeClass('d-none');
        if (!headerOpen) {invertHeaderImages() }
        headerOpen = true;
    }
    function headerCloseMenu(otherMenuOpen = false){
        if (!otherMenuOpen){
            $('#nav').removeClass('open').addClass('closed');
            invertHeaderImages();
            headerOpen = false;
        }
        $('#nav-menu-toggle').removeClass('open').addClass('closed');
        $('#nav-menu').addClass('d-none');
    }
    $('#nav-menu-toggle').on('click', function(){
        if ( $('#nav-menu-toggle').hasClass('closed') ){
            headerOpenMenu();
            headerCloseCart(true);
            headerCloseSearch(true);
        } else {
            headerCloseMenu();
        }
    });
    
    ////////////////////////
    // Open/Close Search //
    //////////////////////
    function headerOpenSearch(otherMenuOpen = false){
        $('#nav').removeClass('closed').addClass('open');
        $('#nav-search-toggle').removeClass('closed').addClass('open');
        $('#nav-search').removeClass('d-none');
        if (!headerOpen) {invertHeaderImages() }
        headerOpen = true;
    }
    function headerCloseSearch(otherMenuOpen = false){
        if (!otherMenuOpen){
            $('#nav').removeClass('open').addClass('closed');
            invertHeaderImages();
            headerOpen = false;
        }
        $('#nav-search-toggle').removeClass('open').addClass('closed');
        $('#nav-search').addClass('d-none');
    }
    $('#nav-search-toggle').on('click', function(){
        if ( $('#nav-search-toggle').hasClass('closed') ){
            headerOpenSearch();
            headerCloseMenu(true);
            headerCloseCart(true);
        } else {
            headerCloseSearch();
        }
    });
    
    //////////////////////
    // Open/Close Cart //
    ////////////////////
    function headerOpenCart(){
        //console.log("headerOpenCart");
        $('#nav').removeClass('closed').addClass('open');
        $('.nav-cart-toggle').removeClass('closed').addClass('open');
        $('#nav-cart').removeClass('d-none');
        if (!headerOpen) {invertHeaderImages() }
        headerOpen = true;
    }
    function headerCloseCart(otherMenuOpen = false){
        if (!otherMenuOpen){
            $('#nav').removeClass('open').addClass('closed');
            invertHeaderImages();
            headerOpen = false;   
        }
        $('.nav-cart-toggle').removeClass('open').addClass('closed');
        $('#nav-cart').addClass('d-none');
    }
    $('.nav-cart-toggle').on('click', function(){
        if ( $('.nav-cart-toggle').hasClass('closed') ){
            headerOpenCart();
            headerCloseSearch(true);
            headerCloseMenu(true);
        } else {
            headerCloseCart();
        }
    });

    ////////////////////////////////
    // Toggle Grid: Product Grid //
    ///////////////////////////////
    $('#toggleGrid').on('click', function(){
        $('#toggleGrid').addClass('active');
        $('#toggleFilter').removeClass('active');
        $('#ProductGridContainer').addClass('product-grid-grid').removeClass('product-grid-filter');
    });

    $('#toggleFilter').on('click', function(){
        $('#toggleGrid').removeClass('active');
        $('#toggleFilter').addClass('active');
        $('#ProductGridContainer').removeClass('product-grid-grid').addClass('product-grid-filter');
        if ($(window).width() < 768){
            if (window.hasOwnProperty('globofilter')){
                // Toggle the globo filters on mobile
                globofilter.toggleCanvas()
            }
        }
    });

    //////////////
    // Swipers //
    /////////////
    const swiper1 = new Swiper('.slider-01', {
        // Optional parameters
        //direction: 'vertical',
        autoHeight: true,
        loop: false,
        spaceBetween: 30,
        slidesPerView: 1.2,
        //mousewheel: true,
        //mousewheelControl: true,
        // Disable preloading of all images
        preloadImages: false,
        // Enable lazy loading
        lazy: {
            enabled: true,
            preloaderClass: "preloader",
            checkInView: true,
        },
        watchSlidesProgress: true, // Needed for lazy loading


        breakpoints: {
            '1': {
                slidesPerView: 1.1,
                spaceBetween: 10,
                mousewheel: true,
              },
              '576': {
                slidesPerView: 1.1,
                spaceBetween: 10,
                mousewheel: true,
              },
              '768': {
                slidesPerView: 1.75,
                spaceBetween: 30,
                mousewheel: true,
              },
              '992': {
                slidesPerView: 2.25,
                spaceBetween: 30,
                mousewheel: true,
              },
              '1200': {
                slidesPerView: 2.5,
                spaceBetween: 30,
                mousewheel: true,
              },
              '1400': {
                slidesPerView: 2.75,
                spaceBetween: 30,
                mousewheel: true,
              },
        },
    });
    window.swiper1 = swiper1;

    window.addEventListener('fromentalSlider01Update', function (e) {
        // Trigger update of slider-01
        console.log("fromentalSlider01Update");
        swiper1.update();
    });

    const swiper2 = new Swiper('.slider-02', {
        // Optional parameters
        //direction: 'vertical',
        autoHeight: true,
        loop: false,
        spaceBetween: 30,
        slidesPerView: 3.5,
        mousewheelControl: true,
        mousewheel: true,

        breakpoints: {
            '1': {
              slidesPerView: 1.1,
              spaceBetween: 10,
              mousewheel: true,
            },
            '576': {
              slidesPerView: 1.1,
              spaceBetween: 10,
              mousewheel: true,
            },
            '768': {
              slidesPerView: 2.5,
              spaceBetween: 30,
              mousewheel: true,
            },
            '992': {
                slidesPerView: 2.75,
                spaceBetween: 30,
              mousewheel: true,
            },
            '1200': {
                slidesPerView: 3.25,
                spaceBetween: 30,
              mousewheel: true,
            },
            '1400': {
                slidesPerView: 3.5,
                spaceBetween: 30,
              mousewheel: true,
            },
        }
    });
    window.swiper2 = swiper2;

    const swiper3 = new Swiper('.slider-03', {
        // Optional parameters
        //direction: 'vertical',
        //autoHeight: true,
        loop: false,
        spaceBetween: 30,
        slidesPerView: 3.3,
        mousewheelControl: true,
        mousewheel: true,

        breakpoints: {
            '1': {
              slidesPerView: 1.1,
              spaceBetween: 10,
              mousewheel: true,
            },
            '576': {
              slidesPerView: 1.2,
              spaceBetween: 15,
              mousewheel: true,
            },
            '768': {
              slidesPerView: 2.5,
              spaceBetween: 30,
              mousewheel: true,
            },
            '992': {
                slidesPerView: 2.75,
                spaceBetween: 30,
                mousewheel: true,
            },
            '1200': {
                slidesPerView: 3.3,
                spaceBetween: 30,
                mousewheel: true,
            },
            '1400': {
                slidesPerView: 3.3,
                mousewheel: true,
                spaceBetween: 30,
            },
        }
    });
    window.swiper3 = swiper3;

    // Hide last slide on mobile by default
    if (window.innerWidth < 768){
        console.log("remove last slide..");
        window.fromental.sliders.desktop = false;
        // swiper 1
        if (swiper1.length !== undefined){
            for (let i = 0; i < swiper1.length; i++){
                var s = swiper1[i];
                s.removeSlide(s.slides.length -1);
            }  
        } else if (swiper1.slides.length){
            swiper1.removeSlide(swiper1.slides.length -1);
        }
        // swiper 2
        if (swiper2.length !== undefined){
            for (let i = 0; i < swiper2.length; i++){
                var s = swiper2[i];
                s.removeSlide(s.slides.length -1);
            }
        } else if (swiper2.slides.length){
            swiper2.removeSlide(swiper2.slides.length -1);
        }
        // swiper 3
        if (swiper3.length !== undefined){
            for (let i = 0; i < swiper3.length; i++){
                var s = swiper3[i];
                s.removeSlide(s.slides.length -1);
            }
        } else if (swiper3.slides.length){
            swiper3.removeSlide(swiper3.slides.length -1);
        }  
    }

    // Watch window resize and add/remove last slide on mobile sizes
    $( window ).on("resize", function() {
        if (window.innerWidth < 768 && window.fromental.sliders.desktop){
            console.log("remove last slide..");
            window.fromental.sliders.desktop = false;
            // swiper 1
            if (swiper1.length !== undefined){
                for (let i = 0; i < swiper1.length; i++){
                    var s = swiper1[i];
                    s.removeSlide(s.slides.length -1);
                }  
            } else if (swiper1.slides.length){
                swiper1.removeSlide(swiper1.slides.length -1);
            }
            // swiper 2
            if (swiper2.length !== undefined){
                for (let i = 0; i < swiper2.length; i++){
                    var s = swiper2[i];
                    s.removeSlide(s.slides.length -1);
                }
            } else if (swiper2.slides.length){
                swiper2.removeSlide(swiper2.slides.length -1);
            }
            // swiper 3
            if (swiper3.length !== undefined){
                for (let i = 0; i < swiper3.length; i++){
                    var s = swiper3[i];
                    s.removeSlide(s.slides.length -1);
                }
            } else if (swiper3.slides.length){
                swiper3.removeSlide(swiper3.slides.length -1);
            }  
        }
        if (window.innerWidth > 767 && !window.fromental.sliders.desktop){
            console.log("add last slide");
            window.fromental.sliders.desktop = true;
            // swiper 1
            if (swiper1.length !== undefined){
                for (let i = 0; i < swiper1.length; i++){
                    var s = swiper1[i];
                    s.appendSlide('<div class="slide swiper-slide slide-last"></div>')
                }  
            } else if (swiper1.slides.length){
                swiper1.appendSlide('<div class="slide swiper-slide slide-last"></div>')
            }
            // swiper 2
            if (swiper2.length !== undefined){
                for (let i = 0; i < swiper2.length; i++){
                    var s = swiper2[i];
                    s.appendSlide('<div class="slide swiper-slide slide-last"></div>')
                }
            } else if (swiper2.slides.length){
                swiper2.appendSlide('<div class="slide swiper-slide slide-last"></div>')
            }
            // swiper 3
            if (swiper3.length !== undefined){
                for (let i = 0; i < swiper3.length; i++){
                    var s = swiper3[i];
                    s.appendSlide('<div class="slide swiper-slide slide-last"></div>')
                }
            } else if (swiper3.slides.length){
                swiper3.appendSlide('<div class="slide swiper-slide slide-last"></div>')
            } 
        }
    });

    const swiper_case_studies = new Swiper('.slider-case-studies', {
        // Optional parameters
        //direction: 'vertical',
        autoHeight: true,
        loop: true,
        spaceBetween: 10,
        slidesPerView: 1.15,
        centeredSlides: true,
        //mousewheel: true,
        //mousewheelControl: true,

        breakpoints: {
            '768': {
              slidesPerView: 1.3,
              spaceBetween: 30,
              mousewheel: true,
            }
        }
    });

    ///////////////////////////////
    //// Product Enquire Form ////
    /////////////////////////////
    window.fromental.enquire_form = {
        open: false // When open second click will submit form
    }
    $('.enquire-form-button').on('click', function(event){
        if (window.fromental.enquire_form.open){
            $('.enquire-form form').trigger('submit');
        } else {
            event.preventDefault();
            $('.enquire-form form').fadeIn();
            window.fromental.enquire_form.open = true;
        }
    })
    if ( $('.enquire-form').length ){
        // Unhide form is submission detected
        if (
            window.location.search.includes("contact_posted")
            || window.location.search.includes("form_type")
        ){
            window.fromental.enquire_form.open = true;
            $('.enquire-form form').show();
        }
        // Hide submission button if success detected
        if ( $('.enquire-form-success').length ){
            $('.enquire-form-button').hide();
        }
    }

    //////////////////////////////
    //// Product Media Modal ////
    ////////////////////////////
    const swiper_media = new Swiper('.slider-media', {
        // configure Swiper to use modules
        modules: [Navigation, Mousewheel],
        // Optional parameters
        //direction: 'vertical',
        //autoHeight: true,
        loop: true,
        spaceBetween: 30,
        slidesPerView: 1.2,
        centeredSlides: true,
        mousewheel: true,
        //mousewheelControl: true,
        /*
        mousewheel: {
            enabled: true,
            eventsTarget : '.modal-body .slider',
            forceToAxis: false,
            invert: false,
            releaseOnEdges: false,
            sensitivity: 1,
        },
        observer: true,
        observeParents: true,
        */
        // If we need pagination
        //pagination: {
        //  el: '.swiper-pagination',
        //},
      
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      
        // And if we need scrollbar
        //scrollbar: {
        //  el: '.swiper-scrollbar',
        //},
    });
    var mediaModalEl = document.getElementById('mediaModal');
    if (mediaModalEl){
        mediaModalEl.addEventListener('shown.bs.modal', function (event) {
            // Re-init swiper
            swiper_media.update();
        });
    }

    /////////////////////////
    //// VIDEO DEFERRED ////
    ///////////////////////
    $('.video-deferred ').on('click', function(){
        var template = $(this).find('template');
        $(this).find('img').hide();
        $(this).find('.overlay').hide();
        $(this).html(template.html());
    })


    ///////////////////////
    //// VIDEO SLIDER ////
    /////////////////////
    if ($('.video-slider').length){
        $('.video-slider').each( function(){
            var slider = $(this);
            var switchSlide = function(obj){
                var active = "0";
                if (slider.find('.slide.active video').length){
                    slider.find('.slide.active video')[0].pause(); // Pause active video
                    slider.find('.slide.active video')[0].currentTime = 0; // rewind
                }
                var index = $(obj).attr("data-slide-index"); // Get index of new slide

                slider.find('.indicator').not(obj).removeClass('active'); // unset active on all other indicators
                $(obj).addClass('active'); // Set this indicator active
                slider.find('.slide.active').fadeOut('slow').removeClass('active'); // fade out active slide
                var new_slide = slider.find('.slide:eq(' + index + ')'); // ref to new slide
                new_slide.fadeIn('slow').addClass('active'); // fade in new slide
                if (new_slide.find('video').length){
                    new_slide.find('video')[0].play(); // Play new video
                }
                slider.find('.current_heading').text(new_slide.attr('data-heading')); // swap out heading
                slider.find('.current_subheading').text(new_slide.attr('data-subheading'));
            }
            slider.find('.indicator').on("fakeClick", function(){
                // Use custom event fakeClick to prevent clearInterval from being triggered
                switchSlide(this);
            });
            slider.find('.indicator').on("click", function(){
                clearInterval(window.fromental.video_slider_interval); // Clear interval
                switchSlide(this);
            });

            window.fromental.video_slider = {
                desktop: true, // Set false when moved to mobile side
                slide_duration : parseFloat($('.video-slider').first().attr('data-slide-duration') * 1000)
            }
            window.fromental.video_slider_interval = setInterval(function(){
                var active_indicator = $('#video-slider-controls .indicator.active');
                if (active_indicator.next().length){
                    active_indicator.next().trigger( "fakeClick" );
                } else {
                    $('#video-slider-controls .indicator').first().trigger( "fakeClick" );
                }
            }, window.fromental.video_slider.slide_duration)
        });

        // Check if mobile view and move video into mobile side
        // use window.innerWidth as $(window).width() returns wrong window size
        if (window.innerWidth < 768){
            //console.log("move videos to mobile side: " + $(window).width());
            window.fromental.video_slider.desktop = false;
            var element = $('.video-slider .right .slider').detach();
            $('.video-slider .mobile-videos').append(element);  
        }

        // Watch window resize and move slider into mobile videos
        $( window ).on("resize", function() {
            if (window.innerWidth < 768 && window.fromental.video_slider.desktop){
                window.fromental.video_slider.desktop = false;
                var element = $('.video-slider .right .slider').detach();
                $('.video-slider .mobile-videos').append(element);
            }
            if (window.innerWidth > 767 && !window.fromental.video_slider.desktop){
                window.fromental.video_slider.desktop = true;
                var element = $('.video-slider .mobile-videos .slider').detach();
                $('.video-slider .right').append(element);
            }
        });
        
    }


});
